import React, { ReactNode } from 'react'
import styled from 'styled-components'

interface Props {
    label?: ReactNode
    required?: boolean
    fullWidth?: boolean
    className?: string
    children: ReactNode
}

const FormField: React.FC<Props> = ({
    label,
    required,
    fullWidth = false,
    className,
    children,
}) => (
    <FieldWrap $fullWidth={fullWidth} className={className}>
        {(label || required) && (
            <Label>
                {label}
                {required && <Req aria-hidden> *</Req>}
            </Label>
        )}
        {children}
    </FieldWrap>
)

export default FormField

const FieldWrap = styled.div<{ $fullWidth?: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
    min-width: 0;
    ${({ $fullWidth }) => $fullWidth && `grid-column: 1 / -1;`}
`

const Label = styled.span`
    font-family: ${({ theme }) => theme.fonts.sans};
    font-size: 0.75rem;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.ink2};
    text-align: start;
`

const Req = styled.span`
    color: ${({ theme }) => theme.colors.danger};
`
